export type Stav = "zdravy" | "slabsi" | "nemocny" | "uschly" | "planovany";
export type PhotoKind = "rostlina" | "stitek" | "list" | "kvet" | "plod" | "kura" | "jine";
export type GardenRole = "owner" | "write" | "read";

export interface Parcel {
  id: string; garden_id: string; ruian_id: number; ku_kod: number; ku_nazev: string; cislo: string;
  druh_pozemku: number | null; vymera: number | null; geometry: { type: "Polygon" | "MultiPolygon"; coordinates: any };
}
export interface Garden {
  id: string;
  name: string;
  mode?: "map" | "photo";
  photo_width?: number | null;
  photo_height?: number | null;
  photo_blob?: Blob;
  parent_id?: string | null;
  parent_lat?: number | null;
  parent_lng?: number | null;
  role?: GardenRole;
  owner_email?: string;
  parcels: Parcel[];
  created_at?: string;
  updated_at?: string;
}
export interface GardenShare {
  id: string;
  email: string;
  role: "read" | "write";
  created_at: string;
}

export interface Identification { score: number; latin: string; names: string[]; genus: string; family: string }

export interface Plant {
  id: string; garden_id: string; cislo: number | null; druh: string; odruda: string; rok: number | null; podnoz: string;
  stav: Stav; poznamka: string; lat: number; lng: number; parcela: string;
  urceni?: { at: string; results: Identification[] } | null;
  updated_at: string; deleted_at?: string | null;
}

export interface Photo {
  id: string; plant_id: string; garden_id: string; kind: PhotoKind; created_at: string; deleted_at?: string | null;
  /** present while the photo exists only on this device (or as a local copy) */
  blob?: Blob; thumb?: Blob; uploaded?: boolean;
}

export type OutboxOp =
  | { key: string; type: "plant"; id: string; garden_id: string; at: number }
  | { key: string; type: "plant-delete"; id: string; garden_id: string; at: number }
  | { key: string; type: "photo"; id: string; garden_id: string; at: number }
  | { key: string; type: "photo-delete"; id: string; garden_id: string; at: number };

export const STAVY: [Stav, string][] = [["zdravy", "Zdravý"], ["slabsi", "Slabší"], ["nemocny", "Nemocný"], ["uschly", "Uschlý"], ["planovany", "Plánovaný"]];
export const STAV_LABEL = Object.fromEntries(STAVY) as Record<Stav, string>;
export const KINDS: [PhotoKind, string][] = [["rostlina", "Rostlina"], ["stitek", "Štítek"], ["list", "List"], ["kvet", "Květ"], ["plod", "Plod"], ["kura", "Kůra"], ["jine", "Jiné"]];
export const KIND_LABEL = { ...Object.fromEntries(KINDS), strom: "Rostlina" } as unknown as Record<PhotoKind, string>;
export const DRUH_POZEMKU: Record<number, string> = {
  2: "orná půda", 3: "chmelnice", 4: "vinice", 5: "zahrada", 6: "ovocný sad", 7: "trvalý travní porost",
  10: "lesní pozemek", 11: "vodní plocha", 13: "zastavěná plocha", 14: "ostatní plocha",
};
